const typeLogList = [
  { type: 1, label: 'totem.query.log.sales.order.number.option' },
  { type: 2, label: 'totem.query.log.sales.document.number.option' },
  { type: 3, label: 'totem.query.log.sales.order.update.option' },
  { type: 4, label: 'totem.query.log.sales.order.separation.option' },
  { type: 5, label: 'totem.query.log.sales.order.deleted.option' },
]

export { typeLogList }
